module.exports = __webpack_public_path__ + "__static/site-1784740481084/media/lion-sound.04b19dcf.mp4";